import { RouteConfig } from 'vue-router'
const Index = () => import('../../views/intelligent-classroom/Index.vue')
const DrillBefore = () => import('../../views/intelligent-classroom/DrillBeforePage.vue')
// const AppointResult = () => import('../../views/intelligent-classroom/AppointResultPage.vue')

export const intelligentClassroomStudentHomeRoute: RouteConfig = {
  path: '/intelligent-classroom-student-home',
  name: 'intelligent_classroom_student_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生端',
  },
}

export const intelligentClassroomStudentDrillBeforeRoute: RouteConfig = {
  path: '/intelligent-classroom-student-drill-before',
  name: 'intelligent_classroom_student_drill_before',
  component: DrillBefore,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生端',
  },
}

export default [intelligentClassroomStudentHomeRoute, intelligentClassroomStudentDrillBeforeRoute]
